import {
  QUICK_SEARCH_ERROR,
  QUICK_SEARCH_QUERY,
  QUICK_SEARCH_RECEIVE,
  QUICK_SEARCH_SELECT_ITEM,
  QUICK_SEARCH_SHOW,
} from '../constants';
import { post } from '../Services/http';
import { catchError } from './Error.action';
import { dataLayerSearch } from '../Services/Gtm.service';

let queryAbortController;
let initialAbortController;

const abortQuery = () => {
  if (queryAbortController) {
    queryAbortController.abort();
    queryAbortController = null;
  }
};

const abortInitial = () => {
  if (initialAbortController) {
    initialAbortController.abort();
    initialAbortController = null;
  }
};

export const query = (q) => (dispatch, getState) => {
  abortQuery();
  abortInitial();

  queryAbortController = new AbortController();

  return post('/api/quickSearch', q, queryAbortController)
    .then((response) => response.json())
    .then((result) => {
      dispatch(receive(result));
      queryAbortController = null;
    })
    .catch((ex) => {
      if (ex.name !== 'AbortError') {
        dispatch(catchError(ex, searchError));
      }
      queryAbortController = null;
    });
};

export const setSearchQuery = (query) => ({
  type: QUICK_SEARCH_QUERY,
  payload: {
    query,
  },
});

export const searchError = (error) => ({
  type: QUICK_SEARCH_ERROR,
  payload: {
    error,
  },
});

export const receive = (result) => ({
  type: QUICK_SEARCH_RECEIVE,
  payload: {
    result: result,
    show: true,
  },
});

export const receiveInitial = (result) => ({
  type: QUICK_SEARCH_RECEIVE,
  payload: {
    result: result,
    show: true,
    popularSearches: result.popularSearches,
    popularLinks: result.popularLinks,
  },
});

export const hide = () => (dispatch) => {
  dispatch(toggleShow(false));
};

const toggleShow = (visible) => ({
  type: QUICK_SEARCH_SHOW,
  payload: {
    show: visible,
  },
});

export const handleKeyDown = (event, opt) => (dispatch, getState) => {
  const { result, selectedItem, query } = getState().quickSearch;
  const max = result.length - 1;
  const clip = (index) => (index < 0 ? max : index > max ? 0 : index);

  switch (event.keyCode) {
    case 38: // Up arrow
      event.preventDefault();
      dispatch(selectItem(clip(selectedItem - 1)));
      break;
    case 40: // Down arrow
      event.preventDefault();
      dispatch(selectItem(clip(selectedItem + 1)));
      break;
    case 13: // Enter
      event.preventDefault();
      const selectedObject = result[selectedItem];
      if (selectedObject && selectedObject.url) {
        location.href = selectedObject.url;
      } else {
        dataLayerSearch(decodeURIComponent(query || ''));
        location.href = opt.searchUrl;
      }
      break;
    default:
      break;
  }
};

export const handleClickSearch = (opt) => (dispatch, getState) => {
  const { result, query } = getState().quickSearch;
  if (!result || !result.length) {
    return;
  }
  dataLayerSearch(decodeURIComponent(query || ''));
  location.href = opt.searchUrl;
};

export const openInitialResult = () => (dispatch) => {
  // Cancel any existing requests - new initial result replaces everything
  abortInitial();
  abortQuery();

  initialAbortController = new AbortController();

  return post('/api/quickSearch/intialresult', null, initialAbortController)
    .then((response) => response.json())
    .then((result) => {
      dispatch(receiveInitial(result));
      initialAbortController = null; // Clear after success
    })
    .catch((ex) => {
      // Don't dispatch error for aborted requests
      if (ex.name !== 'AbortError') {
        dispatch(catchError(ex, searchError));
      }
      initialAbortController = null;
    });
};

const selectItem = (selectedItem) => ({
  type: QUICK_SEARCH_SELECT_ITEM,
  payload: {
    selectedItem,
  },
});
